export default __webpack_public_path__ + "static/lucas_n-b00d117c7df172de5c211e3a9b4bab07.png";